import * as React from 'react'
import { Route, Switch } from 'react-router'
import { ConnectedRouter } from 'connected-react-router'
import { history } from '../../../history'
import { isProduction } from '../../../utilities'

import { NonEventHomeWithData } from '../../home/standard-site'
import Styleguide from '../../styleguide/Styleguide'
import { PageWithData } from '../../page'
import { Finalist } from '../../custom-page/finalist/Finalist'
import { AccountArea, UploadArea } from '../../account'
import { Subscribe } from '../../custom-page/subscribe/Subscribe'

class StandardSite extends React.Component {
    render() {
        return (
            <ConnectedRouter history={history}>
                <Switch>
                    <Route exact={true} path='/' component={NonEventHomeWithData} />
                    { !isProduction ?
                        <Route exact={true} path='/style-guide' component={Styleguide} /> :
                        null
                    }
                    <Route exact={true} path='/account' component={AccountArea} />
                    <Route exact={true} path='/account/upload' component={UploadArea} />
                    <Route exact={true} path='/ironshopper' component={Finalist} />
                    <Route exact={true} path='/subscribe' component={Subscribe} />
                    <Route path='/:slug' component={PageWithData} />
                </Switch>
            </ConnectedRouter>
        )
    }
}

export default StandardSite
